export default __webpack_public_path__ + "static/media/icon-menu-orange.c37401ea.svg";